import Footer from '@tcs/create-account/components/Footer';
import Header from '@tcs/create-account/components/Header';
import Error404 from '@tcs/create-account/containers/Error404';
import { NOT_FOUND_URL } from '@tcs/create-account/utils/routes';
import { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useLocation, useNavigate } from 'react-router';
import usePartnerConfig from '../hooks/usePartnerConfig';

const CreateAccount404 = () => {
  const { loading, data } = usePartnerConfig();
  const location = useLocation();
  const nav = useNavigate();

  useEffect(() => {
    if (location.pathname !== location.pathname.toLowerCase()) {
      nav(location.pathname.toLowerCase());
    }
  }, [location.pathname, nav]);

  if (loading) {
    return null;
  }

  return (
    <>
      {/* @ts-ignore */}
      <Helmet>
        <title>404 Not Found</title>
        <link rel="canonical" href={NOT_FOUND_URL} />
      </Helmet>

      <Header data={data.header} />
      <Error404 />
      <Footer data={data.footer} />
    </>
  );
};

export default CreateAccount404;
